import React from 'react';
import { NavLink, Link } from 'react-router-dom';

function Navbar() {
    return (
        <nav className="header-bar">
            <div className="nav-content">
                <div className="nav-left" style={{ display: 'flex', alignItems: 'center', gap: '1rem', background: 'transparent' }}>
                    <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '1rem', textDecoration: 'none', background: 'transparent' }}>
                        
                        <img src="/assets/bendall-logo.png" alt="Bendall" style={{ height: '40px', width: 'auto', background: 'transparent', verticalAlign: 'baseline' }} />
                        <span style={{ fontSize: '2rem', fontWeight: 500, color: '#dfdfdf', background: 'transparent', verticalAlign: 'baseline', display: 'inline-block', transform: 'translateY(0px)' }}>Laboratory</span>
                    </Link>
                </div>
                <div className="nav-right">
                    <NavLink to="/" end className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>Home</NavLink>
                    <NavLink to="/people" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>People</NavLink>
                    <NavLink to="/research" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>Research</NavLink>
                    <NavLink to="/lab" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>The Lab</NavLink>
                    <NavLink to="/publications" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>Publications</NavLink>
                    <NavLink to="/contact" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>Contact</NavLink>
                </div>
            </div>
        </nav>
    );
}

export default Navbar;
